var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.542 4.675c1.683 2.158 4.791 6.158 4.791 6.158v5c0 .459.375.834.834.834h1.667a.836.836 0 0 0 .833-.834v-5s3.1-4 4.783-6.158a.832.832 0 0 0-.658-1.342H4.2a.832.832 0 0 0-.658 1.342z"
})));
export default SvgFilter;